import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=3dc8a043"
import script from "./PaymentGateway.vue?vue&type=script&lang=js"
export * from "./PaymentGateway.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&id=3dc8a043&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports